module.exports = __webpack_public_path__ + "static/hobgoblin_iron_shadow-4514c437f05bad9a269c8fedd4292f82.jpeg";